import React from 'react';
import PropTypes from 'prop-types';
import { trackCustomEvent } from '@client/tracking/GTM';
import {
  EVENT_SHARE,
  METHOD_FACEBOOK,
  METHOD_LINKEDIN,
  METHOD_EMAIL,
} from '@client/definitions/tracking';
import { FacebookSvg } from '../icons/social/FacebookSvg';
import { LinkedInSvg } from '../icons/social/LinkedInSvg';
import { EmailSvg } from '../icons/social/EmailSvg';
import styles from './socialMediaSharing.scss';

class SocialMediaSharing extends React.Component {
  constructor(props) {
    super(props);
  }

  handleShareClick = (method, url) => {
    trackCustomEvent(EVENT_SHARE, {
      method: method,
      content_type: url,
    });
  };

  render() {
    const { className, url, hashtag, hideEmail } = this.props;

    return (
      <div
        className={`${styles.socialMediaSharing}${
          className ? ` ${className}` : ''
        }`}
      >
        <a
          className={styles.smButton}
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&hashtag=%23${encodeURIComponent(
            hashtag || ''
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => this.handleShareClick(METHOD_FACEBOOK, url)}
        >
          <FacebookSvg />
        </a>
        <a
          className={styles.smButton}
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
            url
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => this.handleShareClick(METHOD_LINKEDIN, url)}
        >
          <LinkedInSvg />
        </a>
        {!hideEmail && (
          <a
            className={`${styles.smButton}`}
            href={`mailto:?subject=${encodeURIComponent(
              this.props.title || ''
            )}&body=${encodeURIComponent(url)}`}
            onClick={() => this.handleShareClick(METHOD_EMAIL, url)}
          >
            <EmailSvg />
          </a>
        )}
      </div>
    );
  }
}

SocialMediaSharing.propTypes = {
  className: PropTypes.string,
  fundraiserId: PropTypes.string,
  url: PropTypes.string.isRequired,
  hashtag: PropTypes.string,
  via: PropTypes.string,
  title: PropTypes.string,
  hideEmail: PropTypes.bool,
  beforeOnClick: PropTypes.func,
};

export default SocialMediaSharing;
